function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import InAppMessage from "./in-app-message.js";
import { DOMUtils as ue } from "../../util/dom-utils.js";

var SlideUpMessage = /*#__PURE__*/function (_InAppMessage) {
  _inherits(SlideUpMessage, _InAppMessage);

  var _super = _createSuper(SlideUpMessage);

  function SlideUpMessage(e, t, s, o, i, r, n, d, a, u, p, m, c, l, v, x, f, h, g, I, M, b) {
    var _this;

    _classCallCheck(this, SlideUpMessage);

    x = x || InAppMessage.th.Mh, v = v || InAppMessage.th.Rh, _this = _super.call(this, e, t = t || InAppMessage.TextAlignment.START, s, o, i, r, n, d, a, u, p, m, void 0, c, l, v, x, f, h, g, void 0, void 0, void 0, void 0, void 0, void 0, void 0, I, M, b), _this.$o = InAppMessage.TextAlignment.START;
    return _this;
  }

  _createClass(SlideUpMessage, [{
    key: "vo",
    value: function vo() {
      return !1;
    }
  }, {
    key: "zo",
    value: function zo() {
      var e = document.createElement("span");
      return e.appendChild(document.createTextNode(this.message || "")), e;
    }
  }, {
    key: "Ah",
    value: function Ah(e) {
      var t = e.getElementsByClassName("ab-in-app-message")[0];
      ue.Ho(t, !0, !0) || (this.slideFrom === InAppMessage.SlideFrom.TOP ? t.style.top = "0px" : t.style.bottom = "0px"), _get(_getPrototypeOf(SlideUpMessage.prototype), "Ah", this).call(this, e);
    }
  }, {
    key: "bt",
    value: function bt() {
      return _get(_getPrototypeOf(SlideUpMessage.prototype), "bt", this).call(this, SlideUpMessage.cs);
    }
  }], [{
    key: "Qr",
    value: function Qr(e) {
      return new SlideUpMessage(e[InAppMessage.es.ra], e[InAppMessage.es.sa], e[InAppMessage.es.Sh], e[InAppMessage.es.qs], e[InAppMessage.es.ta], e[InAppMessage.es.ia], e[InAppMessage.es.URI], e[InAppMessage.es.oa], e[InAppMessage.es.pa], e[InAppMessage.es.ma], e[InAppMessage.es.na], e[InAppMessage.es.ls], e[InAppMessage.es.ca], e[InAppMessage.es.fa], e[InAppMessage.es.da], e[InAppMessage.es.la], e[InAppMessage.es.ga], e[InAppMessage.es.ja], e[InAppMessage.es.xa], e[InAppMessage.es.ka], e[InAppMessage.es.CSS], e[InAppMessage.es.qa]);
    }
  }]);

  return SlideUpMessage;
}(InAppMessage);

export { SlideUpMessage as default };
SlideUpMessage.cs = InAppMessage.bo.Wr;